import { createFileRoute } from "@tanstack/react-router";

import { CompanyScreen } from "../features/company/CompanyScreen.tsx";

export const Route = createFileRoute("/_app/company")({
  component: CompanyScreen,
});
